import React from 'react';
import { Package, Edit, Trash2, ChevronRight } from 'lucide-react';

const ModuleCard = ({ module, onEdit, onDelete, onViewParts }) => {
  const statusColors = {
    PENDING: 'bg-amber-50 text-amber-700 border-amber-200',
    IN_PROGRESS: 'bg-blue-50 text-blue-700 border-blue-200',
    COMPLETED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    CANCELLED: 'bg-red-50 text-red-700 border-red-200'
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:border-gray-300 transition-colors">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
            <Package className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">{module.module_code}</h3>
            <p className="text-sm text-gray-500">{module.module_name}</p>
          </div>
        </div>
        <span className={`px-2 py-1 text-xs font-medium rounded border ${statusColors[module.status] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
          {module.status}
        </span>
      </div>

      {module.furniture_item_name && (
        <p className="text-sm text-gray-600 mb-3">
          <span className="font-medium">Item:</span> {module.furniture_item_name}
        </p>
      )}

      {module.total_width && module.total_height && (
        <p className="text-sm text-gray-600 mb-3">
          <span className="font-medium">Dimensões:</span> {module.total_width} x {module.total_height} x {module.total_depth || '-'}mm
        </p>
      )}

      <div className="flex items-center justify-between pt-3 border-t border-gray-200">
        <button
          onClick={() => onViewParts?.(module)}
          className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 font-medium"
        >
          Ver Peças
          <ChevronRight className="w-4 h-4" />
        </button>

        <div className="flex items-center gap-2">
          <button
            onClick={() => onEdit?.(module)}
            className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
          >
            <Edit className="w-4 h-4" />
          </button>
          <button
            onClick={() => onDelete?.(module)}
            className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModuleCard;
